/**
 * @file 路由配置
 */
import Vue from 'vue';
import Router from 'vue-router';
import order from './order';
import policy from './policy';
import system from './system';
import publish from './publish';
import {getUserAuth} from '@/modules/global/auth';
Vue.use(Router);

const root = {
    path: '/',
    redirect: '/order'
};
// 404
const notFound = {
    path: '/notFound',
    meta: {
        single: true
    },
    component(resolve) {
        require.ensure([], () => resolve(require('@/modules/global/notFound')));
    }
};

const login = {
    path: '/login',
    name: 'login',
    meta: {
        requiresAuth: true,
        label: '登陆页',
        single: true
    },
    component(resolve) {
        require.ensure([], () => resolve(require('@/modules/login')));
    }
};
// const home = {
//     path: '/home',
//     name: 'home',
//     icon: 'el-icon-s-home',
//     meta: {
//         requiresAuth: true,
//         label: '首页'
//     },
//     component(resolve) {
//         require.ensure([], () => resolve(require('@/modules/home')));
//     }
// };
const detail = {
    path: '/:type/:module/detail/:id',
    component: () => import('@/modules/detail')
}

const bidDetail = {
    path: '/audit/bid/bidDetail/:id',
    component: () => import('@/modules/bidDetail')
}


export let router =  new Router({
    // mode: 'history',
    base: process.env.BASE_URL,
    routes: [root, notFound, login, detail, bidDetail, order, policy, system, publish]
});
// todo登录前判断路由的跳转
router.beforeEach(async (to, from, next) => {
	// 404 page
    if (to.matched.length === 0) {
        // router.push({path: '/notFound'});
        return;
    }
    // 做权限控制
    await getUserAuth(router);
    next();
});
export default router;


